module.exports = __webpack_public_path__ + "img/pin-google.aee8b68b.svg";